import { BoxProps } from "@chakra-ui/react";
import { FC } from "react";
import { Box } from "Shared";

export const ContainerMarketing: FC<BoxProps> = (props) => {
  return (
    <Box maxWidth="90rem" mx="auto" px={[6, null, null, 10]} {...props}></Box>
  );
};
